import React, { Component } from 'react';
import { withApollo } from '@apollo/react-hoc';
import { Checkbox, Button, Form } from 'antd';
import { gql } from '@apollo/client';

import styles from './styles.scss';

const ACCEPT_TERMS = gql`
  mutation AcceptTerms {
    acceptTerms {
      user {
        uuid
        termsAt
      }
    }
  }
`;

class EulaBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  onFinish = async () => {
    this.setState({
      loading: true,
    });

    const { client } = this.props;

    await client.mutate({
      mutation: ACCEPT_TERMS,
    });
  };

  render() {
    const { loading } = this.props;

    return (
      <div className={styles.layout}>
        <p>
          In order to use Achievable, you must
          <br />
          agree to the Terms and Conditions.
        </p>
        <Form
          onFinish={this.onFinish}
          className={styles.form}
          initialValues={{ terms: false }}
        >
          <Form.Item
            className={styles.terms}
            name="terms"
            valuePropName="checked"
            rules={[
              {
                required: true,
                transform: (value) => value || undefined,
                type: 'boolean',
                message: 'You must agree to the T&C',
              },
            ]}
          >
            <Checkbox data-aaa="signUpTerms">
              I agree to the{' '}
              <a
                href="https://www.iubenda.com/terms-and-conditions/18707085"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
            </Checkbox>
          </Form.Item>
          <Form.Item>
            <Button
              data-aaa="eulaSubmit"
              type="primary"
              htmlType="submit"
              block
              loading={loading}
            >
              I agree
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withApollo(EulaBlock);
